import React, {
  useMemo,
  useRef,
  useState,
  useCallback,
  useEffect,
} from "react";
import BreadCrumb from "Common/BreadCrumb";
import { PaginationState } from "@tanstack/react-table";
import TableContainer from "Common/TableContainer";
import { Link } from "react-router-dom";
import { TailSpin } from "react-loader-spinner";
import {
  MoreHorizontal,
  Eye,
  FileEdit,
  Trash2,
  Pencil,
  UploadCloud,
} from "lucide-react";
import { Dropdown } from "Common/Components/Dropdown";
import { Download, Plus, Search, SlidersHorizontal } from "lucide-react";
import HTMLReactParser from "html-react-parser";
import DeleteModal from "Common/DeleteModal";
import callApi from "Common/utils/apiCaller";
import * as Yup from "yup";
import { useFormik } from "formik";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import _ from "lodash";
import Drawer from "Common/Components/Drawer";
import ReactSelect from "../../Common/Components/ReactSelect/ReactSelect";
import { X } from "lucide-react";
import Modal from "Common/Components/Modal";
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import { getImageUrl } from "Common/utils/ImageDomain";
import PermissionSwitch from "../../Common/Components/PermissionLocks/PermissionSwitch";
import { imageUploader } from "Common/utils/imageUploader";
import { showNotification } from "Common/utils/Notification";
import descriptionStyle from "../../constants/queryType.json";
import { validateEmail } from "Common/utils/Validation";

const ContactUs = () => {
  const [people, setPeople] = useState([]);
  const [errors, setErrors] = useState<any>("");
  const [queryType, setQueryType] = useState<any>();
  const [loader, setLoader] = useState<any>(false);
  const [search, setSearch] = useState<any>();
  const [email, setEmail] = useState<any>("");
  const [showModel, setShowModel] = useState<boolean>(false);
  const [read, setRead] = useState<any>();
  const defaultToggle = () => setShowModel(!showModel);
  const [imageLink, setImageLink] = useState<any>("");
  const [pageCount, setPageCount] = useState(0);
  const [eventData, setEventData] = useState<any>();
  const [show, setShow] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [totalItems, setTotalItems] = useState(0);
  const [render, setRender] = useState(false);
  const [selectedImage, setSelectedImage] = useState<any>();
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 30,
  });
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const editor = useRef(null);

  const selectProperties = createSelector(
    (state: any) => state.Login,
    (profile) => ({
      user: profile.user,
      error: profile.error,
      success: profile.success,
      permission: profile.permission,
    })
  );

  const { error, success, user, permission } = useSelector(selectProperties);

  const deleteToggle = () => setDeleteModal(!deleteModal);
  const debouncedHandler = useCallback(
    _.debounce((user: any, render: any, pagination: any) => {
      return fetchDateWithFilters(user, render, pagination);
    }, 700),
    []
  );

  async function fetchDateWithFilters(
    searchByName: any,
    render: any,
    pagination: any
  ) {
    let filters: { [index: string]: any } = {};
    if (searchByName) {
      filters.qtext = searchByName;
    }

    const localData = await callApi("v1/contactus/list", "post", {
      pageNum: pagination.pageIndex + 1,
      pageSize: pagination.pageSize,
      filters,
    });
    let arr = [];
    if (localData?.status === "Success") {
      setPeople([...localData.data.contactUsList]);
      setPageCount(
        Math.ceil(localData.data.contactUsCount / pagination.pageSize)
      );
      setTotalItems(localData.data.contactUsCount);
    }
  }

  const filterSearchData = (e: any) => {
    const search = e.target.value;

    setSearch(search);
  };

  useEffect(() => {
    debouncedHandler(search, render, pagination);
  }, [search, render, pagination]);

  // Delete Data
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell._id) {
      setEventData(cell);
    }
  };

  const handleDelete = async () => {
    if (eventData) {
      //dispatch(onDeleteEmployee(eventData.id));
      const res = await callApi(
        `v1/contactus/${eventData?._id}/update`,
        "post",
        {
          contactUs: { is_deleted: true },
        }
      );
      if (res && res?.status === "Success") {
        setDeleteModal(false);
        setRender(!render);
        toast("Deleted successfully");
      }
    }
  };
  const handleQueryData = (keyName, keyValue) => {
    if (keyValue.value === "Select...") {
      setQueryType({});
    } else {
      setQueryType(keyValue);
    }
  };
  // Update Data
  const handleUpdateDataClick = (ele: any) => {
    let filteredData = descriptionStyle.filter(
      (item) => item.value === ele?.query_type.toLowerCase()
    );
    console.log(filteredData, "filteredData");
    setEventData({ ...ele });
    setEmail(ele?.contact_email);
    setQueryType(filteredData[0]);
    setIsEdit(true);
    setShow(true);
  };

  // validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      contact_name: (eventData && eventData.contact_name) || "",

      query_text: (eventData && eventData.query_text) || "",
    },
    validationSchema: Yup.object({
      contact_name: Yup.string().required("Please enter contact name"),

      query_text: Yup.string().required("Please enter query text"),
    }),

    onSubmit: async (values) => {
      if (isEdit) {
        const updateData = {
          _id: eventData ? eventData._id : 0,
          ...values,
        };
        // update user
        if (!validateEmail(email)) {
          setErrors("Please enter a valid email address.");
          return;
        } else {
          setErrors("");
        }

        try {
          setLoader(true);
          const res = await callApi(
            `v1/contactus/${eventData?._id}/update`,
            "post",
            {
              contactUs: {
                ...values,
                contact_email: email,
                query_type: queryType?.value,
              },
            }
          );
          setLoader(false);
          if (res && res?.status === "Success") {
            setRender(!render);
            showNotification("Updated successfully", "success");
          }
        } catch (e) {
          showNotification("something went wrong", "error");
          setLoader(false);
        }
      } else {
        if (!validateEmail(email)) {
          setErrors("Please enter a valid email address.");
          return;
        } else {
          setErrors("");
        }
        if (!queryType) {
          showNotification("Please select query type");
          return;
        }
        try {
          setLoader(true);
          const res = await callApi(`v1/contactus/new`, "post", {
            contactUs: {
              //   contact_email: "example@example.com",
              //   contact_name: "John Doe",
              //   query_type: "CONTACT_US",
              //   query_text: "I need assistance with my account.",
              ...values,
              contact_email: email,
              query_type: queryType?.value,
            },
          });
          setLoader(false);
          if (res && res?.status === "Success") {
            setRender(!render);
            showNotification("Contact us page created successfully", "success");
          }
        } catch (e) {
          showNotification("something went wrong", "error");
          setLoader(false);
        }
      }
      toggle();
    },
  });

  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      setIsEdit(false);
      setSelectedImage("");
      setQueryType({});
      setEmail("");
    } else {
      setShow(true);
      setEventData("");
      setSelectedImage("");
      validation.resetForm();
    }
  }, [show, validation]);

  const peopleColumns = useMemo(
    () => [
      {
        header: "Name",
        accessorKey: "contact_name",
        enableColumnFilter: false,
        enableSorting: false,
      },

      {
        header: "Contact Email",
        accessorKey: "contact_email",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Query Text",
        accessorKey: "query_text",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Query Type",
        accessorKey: "query_type",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell) => (
          <span>{cell.row.original?.query_type?.toLowerCase()}</span>
        ),
      },
      {
        header: "Tracking Data",
        accessorKey: "query_type",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell) => (
          <>
            <span>
              {cell.row.original?.utm_source
                ? `utm_source:${cell.row.original?.utm_source}${","}`
                : null}{" "}
              {cell.row.original?.utm_medium
                ? `utm_medium:${cell.row.original?.utm_medium}${","}`
                : null}{" "}
              {cell.row.original?.utm_campaign
                ? `utm_campaign:${cell.row.original?.utm_campaign}${","}`
                : null}{" "}
              {cell.row.original?.utm_term
                ? `utm_term:${cell.row.original?.utm_term}${","}`
                : null}{" "}
              {cell.row.original?.loc_physical_ms
                ? `loc_physical_ms:${cell.row.original?.loc_physical_ms}${","}`
                : null}{" "}
              {cell.row.original?.keyword
                ? `keyword:${cell.row.original?.keyword}${","}`
                : null}{" "}
              {cell.row.original?.utm_content
                ? `utm_content:${cell.row.original?.utm_content}${","}`
                : null}{" "}
              {cell.row.original?.campaignid
                ? `campaignid:${cell.row.original?.campaignid}${","}`
                : null}{" "}
              {cell.row.original?.adgroupid
                ? `adgroupid:${cell.row.original?.adgroupid}${","}`
                : null}{" "}
              {cell.row.original?.loc_interest_ms
                ? `loc_interest_ms:${cell.row.original?.loc_interest_ms}${","}`
                : null}{" "}
              {cell.row.original?.matchtype
                ? `matchtype:${cell.row.original?.matchtype}${","}`
                : null}{" "}
              {cell.row.original?.feeditemid
                ? `feeditemid:${cell.row.original?.feeditemid}${","}`
                : null}{" "}
              {cell.row.original?.network
                ? `network:${cell.row.original?.network}${","}`
                : null}{" "}
              {cell.row.original?.device
                ? `device:${cell.row.original?.device}${","}`
                : null}{" "}
              {cell.row.original?.adposition
                ? `adposition:${cell.row.original?.adposition}${","}`
                : null}{" "}
              {cell.row.original?.gclid
                ? `gclid:${cell.row.original?.gclid}${","}`
                : null}{" "}
              {cell.row.original?.adset_id
                ? `adsetid:${cell.row.original?.adset_id}${","}`
                : null}{" "}
              {cell.row.original?.placement
                ? `placement:${cell.row.original?.placement}${","}`
                : null}{" "}
              {cell.row.original?.site_source
                ? `site_source:${cell.row.original?.site_source}${","}`
                : null}{" "}
              {cell.row.original?.campaign_name
                ? `campaign_name:${cell.row.original?.campaign_name}${","}`
                : null}{" "}
              {cell.row.original?.review_campaign
                ? `review_campaign:${cell.row.original?.review_campaign}${","}`
                : null}{" "}
              {cell.row.original?.leadFormFillPage
                ? `leadFormFillPage:${
                    cell.row.original?.leadFormFillPage
                  }${","}`
                : null}{" "}
              {cell.row.original?.landingPage
                ? `landingPage:${cell.row.original?.landingPage}${","}`
                : null}{" "}
            </span>

            {/* {cell.row.original?.tags?.length > 5 ? (
              <span
                style={{
                  color: "#fb801d",
                }}
                onClick={() => {
                  setRead(cell.row.original.tags);
                  defaultToggle();
                }}
              >
                {"..."}more
              </span>
            ) : null} */}
          </>
        ),
      },
      {
        header: "Action",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex gap-3">
            <PermissionSwitch
              hasPermissions={permission.permissions}
              shouldHavePermissions={["contactus:edit"]}
              yes={
                <div
                  data-modal-target="addEmployeeModal"
                  className="flex items-center justify-center transition-all duration-200 ease-linear rounded-md cursor-pointer size-8 edit-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
                  onClick={() => {
                    const data = cell.row.original;
                    handleUpdateDataClick(data);
                  }}
                >
                  <Pencil className="size-4" />
                </div>
              }
              no={<span></span>}
            />
            <PermissionSwitch
              hasPermissions={permission.permissions}
              shouldHavePermissions={["contactus:delete"]}
              yes={
                <Link
                  to="#!"
                  className="flex items-center justify-center transition-all duration-200 ease-linear rounded-md size-8 remove-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
                  onClick={() => {
                    const data = cell.row.original;
                    onClickDelete(data);
                  }}
                >
                  <Trash2 className="size-4" />
                </Link>
              }
              no={<span></span>}
            />
          </div>
        ),
      },
    ],
    []
  );

  console.log(queryType, "queryType");

  return (
    <>
      <React.Fragment>
        <BreadCrumb title="ContactUs" pageTitle="ContactUs" version="" />
        <DeleteModal
          show={deleteModal}
          onHide={deleteToggle}
          onDelete={handleDelete}
        />
        <ToastContainer closeButton={false} limit={1} />
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div className="card-body">
              <div className="flex items-center">
                <h6 className="text-15 grow">ContactUs</h6>
                <div className="shrink-0">
                  <PermissionSwitch
                    hasPermissions={permission.permissions}
                    shouldHavePermissions={["contactus:create"]}
                    yes={
                      <button
                        type="button"
                        className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                        onClick={toggle}
                      >
                        <Plus className="inline-block size-4" />{" "}
                        <span className="align-middle">Add ContactUs</span>
                      </button>
                    }
                    no={
                      <button
                        type="button"
                        disabled={true}
                        className="text-grey btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                        onClick={null}
                      >
                        <Plus className="inline-block size-4" />{" "}
                        <span className="align-middle">Add ContactUs</span>
                      </button>
                    }
                  />
                </div>
              </div>
            </div>
            <div className="!py-3.5 card-body border-y border-dashed border-slate-200 dark:border-zink-500">
              <form action="#!">
                <div className="grid grid-cols-1 gap-5 xl:grid-cols-12">
                  <div className="relative xl:col-span-3">
                    <input
                      type="text"
                      className="ltr:pl-8 rtl:pr-8 search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                      placeholder="Search for name, email..."
                      autoComplete="off"
                      onChange={(e) => filterSearchData(e)}
                    />
                    <Search className="inline-block size-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" />
                  </div>
                </div>
              </form>
            </div>
            <div className="card-body">
              <TableContainer
                isPagination={true}
                columns={peopleColumns || []}
                data={people || []}
                pageCount={pageCount}
                pagination={pagination}
                totalItems={totalItems}
                onPaginationChange={(updater: any) => {
                  const nextState = updater(pagination);
                  if (nextState.pageIndex !== pagination.pageIndex)
                    setPagination(nextState);
                }}
                divclassName="overflow-x-auto"
                tableclassName="w-full whitespace-nowrap"
                theadclassName="ltr:text-left rtl:text-right bg-slate-100 text-slate-500 dark:text-zink-200 dark:bg-zink-600"
                thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-y border-slate-200 dark:border-zink-500"
                tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
                PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
              />
            </div>
          </div>
        </div>
        {/* Employee Modal */}
        <Drawer
          show={show}
          onHide={toggle}
          id="drawerEnd"
          drawer-end="true"
          className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
        >
          <Drawer.Header
            className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
            closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
          >
            <Drawer.Title className="text-15">
              {!!isEdit ? "Edit ContactUs" : "Add ContactUs"}
            </Drawer.Title>
            <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
          </Drawer.Header>
          <Drawer.Body className="h-full p-4 overflow-y-auto">
            <form
              className="create-form"
              id="create-form"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <input type="hidden" value="" name="id" id="id" />
              <input type="hidden" value="add" name="action" id="action" />
              <input type="hidden" id="id-field" />
              <div
                id="alert-error-msg"
                className="hidden px-4 py-3 text-sm text-red-500 border border-transparent rounded-md bg-red-50 dark:bg-red-500/20"
              ></div>
              <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                <div className="xl:col-span-12">
                  <label
                    htmlFor="phoneNumberInput3"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Contact Name
                  </label>
                  <input
                    type="text"
                    id="phoneNumberInput3"
                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    placeholder="Enter Contact Name"
                    name="contact_name"
                    onChange={validation.handleChange}
                    value={validation.values.contact_name || ""}
                  />
                  {validation.touched.contact_name &&
                  validation.errors.contact_name ? (
                    <p className="text-red-400">
                      {validation.errors.contact_name}
                    </p>
                  ) : null}
                </div>
                <div className="xl:col-span-12">
                  <label
                    htmlFor="phoneNumberInput3"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Contact Email
                  </label>
                  <input
                    type="text"
                    id="phoneNumberInput3"
                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    placeholder="Enter contact email"
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setErrors("");
                    }}
                    value={email || ""}
                  />
                  {errors && <p className="text-sm text-red-500">{errors}</p>}
                </div>
                <div className="xl:col-span-12">
                  <div className="mb-4 xl:col-span-6">
                    <label
                      htmlFor="phoneNumberInput3"
                      className="inline-block mb-2 text-base font-medium"
                    >
                      Query Type
                    </label>
                    <ReactSelect
                      versionData={""}
                      options={descriptionStyle}
                      isSearchable={false}
                      isMulti={false}
                      disabled={!!isEdit}
                      placeholder={"Please select query type"}
                      contentType={queryType}
                      handleContentChange={handleQueryData}
                      name={"query"}
                      id={"query-type2"}
                    />
                  </div>
                </div>
                <div className="xl:col-span-12">
                  <label
                    htmlFor="phoneNumberInput3"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Query Text
                  </label>
                  <textarea
                    data-type="text"
                    rows={4}
                    id="phoneNumberInput3"
                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    placeholder="Enter query text"
                    name="query_text"
                    onChange={validation.handleChange}
                    value={validation.values.query_text || ""}
                  />
                  {validation.touched.query_text &&
                  validation.errors.query_text ? (
                    <p className="text-red-400">
                      {validation.errors.query_text}
                    </p>
                  ) : null}
                </div>
              </div>
              <div className="flex justify-end gap-2 mt-4">
                <button
                  type="reset"
                  id="close-modal"
                  data-modal-close="addEmployeeModal"
                  className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                  onClick={toggle}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  id="addNew"
                  disabled={loader}
                  style={{
                    minWidth: "130px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                >
                  {loader ? (
                    <span>
                      <TailSpin
                        visible={true}
                        height="20"
                        width="20"
                        color="#fff"
                      />
                    </span>
                  ) : !!isEdit ? (
                    "Update ContactUs"
                  ) : (
                    "Add ContactUs"
                  )}
                </button>
              </div>
            </form>
          </Drawer.Body>
        </Drawer>
        <Modal
          show={showModel}
          onHide={defaultToggle}
          id="defaultModal"
          modal-center="true"
          className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
          dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600 flex flex-col h-full"
        >
          <Modal.Header
            className="flex items-center justify-between p-4 border-b border-slate-200 dark:border-zink-500"
            closeButtonClass="transition-all duration-200 ease-linear text-slate-500 hover:text-red-500 dark:text-zink-200 dark:hover:text-red-500"
          >
            <Modal.Title className="text-16">{"Text"}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
            {/* <h5 className="mb-3 text-16">{}</h5> */}
            <p className="text-slate-500 dark:text-zink-200">
              {HTMLReactParser(read ?? "")}
            </p>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    </>
  );
};

export default ContactUs;
